import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering / re-parenting for the Knowledge Base page tree.
// Every <ul> in the tree is a Sortable list in one shared group, so a page can
// be dragged between levels. On drop we POST the moved page's id, its new
// parent (from the destination list's data-parent-id) and the new sibling
// order to CompanyBrainEntriesController#move. The form's parent picker is the
// reliable fallback; on any server error we just reload to re-sync.
export default class extends Controller {
  static targets = ["list"]
  static values  = { moveUrl: String }

  connect() {
    this.sortables = this.listTargets.map((list) =>
      Sortable.create(list, {
        group: "kb-tree",
        animation: 150,
        fallbackOnBody: true,
        draggable: "li",
        handle: ".kb-handle",
        ghostClass: "opacity-40",
        onEnd: (event) => this.persist(event),
      })
    )
  }

  disconnect() {
    this.sortables?.forEach((s) => s.destroy())
    this.sortables = null
  }

  persist(event) {
    const list     = event.to
    const parentId = list.dataset.parentId || ""
    const order    = Array.from(list.children).map((li) => li.dataset.id).filter(Boolean)
    const movedId  = event.item.dataset.id

    const body = new URLSearchParams()
    body.append("id", movedId)
    body.append("parent_id", parentId)
    order.forEach((id) => body.append("order[]", id))

    fetch(this.moveUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/plain",
      },
      body,
    }).then((res) => {
      if (!res.ok) window.location.reload()
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
